import { render, staticRenderFns } from "./ForwardSettingNode.vue?vue&type=template&id=440a8406&"
import script from "./ForwardSettingNode.vue?vue&type=script&lang=js&"
export * from "./ForwardSettingNode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports